import log from 'uix/logging'
import {treeAspect, customizeJobRouting} from 'uix/views/utils'

export const job = {
  name: 'job',
  tabGroup: 'job',
  ...treeAspect,
  acl: 'g:admin,g:debug',
  customizeRouting: customizeJobRouting,
  tabs: {
    list: {
      datatype: [10, 20],
      parts: ['JobList'],
      tabGroupDefault: true,
      default: true,
    },
    run: {datatype: [10, 20], parts: ['JobSearch']},
    scheduler: {
      acl: 'g:debug',
      datatype: [10],
      parts: ['SchedulerPanel'],
    },
    id: {
      enabled: ({request, datatype}) => !!request.id && (datatype == 10 || datatype == 20),
      parts: [{align: 'center', type: 'JobInfo'}],
    },
  },
}
